import { Flex, Heading } from "@chakra-ui/react";
import SearchAreaHandleSearch from "../../atom/Search/SearchAreaHandleSearch";
import FeatureList from "./FeatureList";
import { borderRadius, borderStyle } from "../../../utils/styles/styles";
import { FC } from "react";
import { MdInfoOutline } from "react-icons/md";
import { renderLoadingState } from "../../../hooks/table/TableStates";

interface Option {
  code: string | number;
  name: string;
  description: string;
}

interface PickListContentProps {
  features: Option[];
  setFeatures: (features: Option[]) => void;
  originalData: Option[];
  onFeatureClick: (item: Option) => void;
  placeholderText: string;
  iconComponent: React.ElementType;
  iconProps: any;
  title?: string;
  isDisabled?: boolean;
  isLoaded: boolean;
}

const PickListContent: FC<PickListContentProps> = ({
  features,
  setFeatures,
  originalData,
  onFeatureClick,
  placeholderText,
  iconComponent: IconComponent,
  iconProps,
  title,
  isDisabled = false,
  isLoaded = false,
}) => {
  return (
    <Flex
      flex="1"
      direction="column"
      gap="2.5"
      background="white"
      p={4}
      borderRadius={borderRadius}
      border={borderStyle}
    >
      {title && (
        <Heading as="h4" fontSize="xl">
          {title}
        </Heading>
      )}
      <SearchAreaHandleSearch
        setDataTable={setFeatures}
        dataTable={originalData}
        filterFunction={(item: any, searchTerm: string) =>
          item.name?.toLowerCase().includes(searchTerm.toLowerCase())
        }
        placeholderText={placeholderText}
        hasIcon={true}
        isDisabled={isDisabled}
      />
      {isLoaded ? (
        <FeatureList
          features={features}
          setDataTable={setFeatures}
          dataTable={originalData}
          onFeatureClick={onFeatureClick}
          IconComponent={IconComponent}
          IconInfo={MdInfoOutline}
          iconProps={iconProps}
          isDisabled={isDisabled}
        />
      ) : (
        renderLoadingState()
      )}
    </Flex>
  );
};

export default PickListContent;
